export class CanStartPolicyChangeResponse {
    canStart: boolean;
    hasAnotherPolicyChange?: boolean;
    minPolicyChangeStartDate?: string;
    message?: string;
    isDateAvailable?: boolean;
    modules?: CanStartPolicyChangeModule[];

    constructor(data?: CanStartPolicyChangeResponse) {
        if (data) {
            Object.assign(this, data);
        }
    }
}

export class CanStartPolicyChangeModule {
    moduleName: string;
    canStart: boolean;
    message?: string;

    constructor(data?: CanStartPolicyChangeModule) {
        if (data) {
            Object.assign(this, data);
        }
    }
}
